<template>
  <div class="navbar-fixed">
    <nav class="blue-grey darken-1" role="navigation">
      <div class="container h-100">
        <div class="nav-wrapper">
          <div class="hide-on-med-and-down">
            <a href="#/" class="brand-logo right"
              ><i class="large material-icons">stars</i
              ><span> quaese.de</span></a
            >
            <ul class="left hide-on-med-and-down">
              <router-link
                tag="li"
                v-for="route in $router.options.routes"
                :data-alias="route.routeAlias"
                :key="route.routeAlias"
                :to="route.path"
                exact-active-class="active"
              >
                <a>{{ route.title }}</a>
              </router-link>
            </ul>
          </div>
          <div class="hide-on-large-only">
            <a class="brand-logo left click-element" @click="toggleCollapse()"
              ><i class="large material-icons">menu</i></a
            >
            <a href="#/" class="brand-logo right">quaese.de</a>
          </div>
        </div>
      </div>

      <ul
        class="menu-med-and-down blue-grey darken-1 hide-on-large nav-element hide"
        ref="mobileNavElement"
      >
        <router-link
          tag="li"
          v-for="route in $router.options.routes"
          :data-alias="route.routeAlias"
          :key="route.routeAlias"
          :to="route.path"
          exact-active-class="active"
        >
          <a @click="() => toggleCollapse()">{{ route.title }}</a>
        </router-link>
      </ul>
    </nav>
  </div>
</template>

<script>
export default {
  name: "navigation",
  data() {
    return {};
  },

  methods: {
    toggleCollapse() {
      const hideClass = "hide";
      const navElement = this.$refs.mobileNavElement;

      // show/hide navigation
      navElement.classList[
        navElement.classList.contains("hide") ? "remove" : "add"
      ](hideClass);
    },
    navigate: function(evt, route) {
      // navigate to named route
      this.$router.push({ path: route.path });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less"></style>
